import TextOnly from '../../templates/TextOnly';
import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
export class HaveQuestionsView extends Component {

	render () {
		const { contactFormHeading, contactFormContent } =
			this.props.content.faq;
		return (
			<TextOnly
				className='GetInTouch'
				{...{
					content: contactFormContent,
					heading: contactFormHeading,
				}}
			/>
		);
	}

}
export default withLanguageContext(HaveQuestionsView);



// WEBPACK FOOTER //
// ./src/components/views/HaveQuestionsView/HaveQuestionsView.js